var map = {
	"./admin/admin.module.ngfactory": [
		"./src/app/admin/admin.module.ngfactory.js",
		"common",
		"admin-admin-module-ngfactory"
	],
	"./audit/audit.module.ngfactory": [
		"./src/app/audit/audit.module.ngfactory.js",
		"audit-audit-module-ngfactory"
	],
	"./sid/sid.module.ngfactory": [
		"./src/app/sid/sid.module.ngfactory.js",
		"common",
		"sid-sid-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;